const Facilities = ({size, color}) => {

    return (  
        <>
            <svg fill={color} height={size} width={size} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
                viewBox="0 0 948.803 948.803" xmlSpace="preserve">
            <g id="column">
                <path d="M187.254,430.224v447.821H307.97V392.13h-45.146C241.681,410.769,215.806,424.153,187.254,430.224z"/>
                <polygon points="342.97,392.13 342.97,870.338 342.97,878.044 456.906,878.044 456.906,870.338 456.906,392.13 456.906,390.423 
                    342.97,390.423 	"/>
                <path d="M640.838,392.13v485.914h120.715V430.224c-28.551-6.071-54.426-19.455-75.569-38.094H640.838z"/>
                <path d="M773.155,70.758H175.648C78.795,70.758,0,149.554,0,246.407c0,84.072,68.397,152.47,152.47,152.47
                    c37.999,0,75.245-17.18,100.039-45.938c19.657-22.798,31.664-52.363,32.016-84.675c-0.782-47.422-37.607-85.747-82.768-85.747
                    c-45.649,0-82.787,39.156-82.787,87.286h-35c0-67.429,52.839-122.286,117.787-122.286c12.085,0,23.749,1.902,34.733,5.428
                    c37.09,11.907,66.086,42.656,77.492,79.694c12.303,39.952,2.858,85.104-18.404,120.3h357.646
                    c-21.263-35.196-30.708-80.348-18.404-120.3c11.406-37.038,40.402-67.787,77.492-79.694c10.984-3.526,22.648-5.428,34.733-5.428
                    c64.948,0,117.787,54.857,117.787,122.286h-35c0-48.13-37.138-87.286-82.787-87.286c-45.161,0-81.986,38.325-82.768,85.747
                    c0.352,32.312,12.359,61.877,32.016,84.675c24.795,28.759,62.04,45.938,100.039,45.938c84.072,0,152.47-68.397,152.47-152.47
                    C948.803,149.554,870.008,70.758,773.155,70.758z"/>
                <polygon points="491.901,392.13 491.901,870.338 491.901,878.044 605.838,878.044 605.838,870.338 605.838,392.13 605.838,390.423 
                    491.901,390.423 	"/>
            </g>
            </svg>
        </>
    );
}
 
export default Facilities;